import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import TrustDetailsForm from './TrustDetailsForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import WizardCard from 'react/signups/card/common/WizardCard';
import trustDetailsShape from 'react/signups/card/shapes/TrustDetails';

export default function FamilyTrustDetails({ moduleComplete, trustDetails, setTrustDetails }) {
  const validationSchema = Yup.object().shape({
    isTrustee: Yup.string()
      .required('You must confirm that you are the trustee')
      .notOneOf(['no'], 'Please have the trustee sign up for an account or contact us for help.'),
    trustName: Yup.string().required('Please enter a trust name'),
  });

  const handleContinue = (values) =>
    setTrustDetails({ trustName: values.trustName, isTruste: values.isTrustee });

  return (
    <>
      <WizardCard>
        <CardHeader>Tell us a little bit more about this trust </CardHeader>
        <Formik
          initialValues={trustDetails}
          onSubmit={handleContinue}
          validationSchema={validationSchema}
        >
          {({ handleSubmit, handleChange, values }) => (
            <>
              <TrustDetailsForm onChange={handleChange} values={values} />
              <NextPageButton
                disabled={moduleComplete}
                id="cta-trust-name"
                onClick={handleSubmit}
              />
            </>
          )}
        </Formik>
      </WizardCard>
    </>
  );
}

FamilyTrustDetails.propTypes = {
  moduleComplete: PropTypes.bool.isRequired,
  setTrustDetails: PropTypes.func.isRequired,
  trustDetails: trustDetailsShape,
};
